import React from "react";
import { useController, Controller } from "react-hook-form";

export const CheckBox = React.forwardRef((props, ref) => {
  const { field, fieldState } = useController(props);
  const { title, toolTip, style, type, errors, defaultValue, labelClass, containterCls=false, disabled=false ,...others } = props;
  let err = _.get(errors, props.name);

  return (
    <>
      <Controller
        name={props?.name}
        control={props?.control}
        rules={props?.rules}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => (
          <>
            <div className={`flex items-center space-x-3 ${containterCls ? containterCls : ''}`}>
              <label
                title={toolTip ? toolTip : ""}
                className={`pr-1 cursor-pointer md:whitespace-nowrap ${props.titleStyle ? props.titleStyle : ""} ${props.font ? props.font  : "text-base"}  ${labelClass ? labelClass : "text-gray-600"} ${
                  props.rules && errors && err
                    && "text-red-600"
                } ${props?.disabled ? "text-gray-200 cursor-not-allowed" : ""}`}
              >
                <input
                  {...field}
                  checked={
                    field.value == "1" || field.value === true ? true : false
                  }
                  type="checkbox"
                  disabled={disabled}
                  onChange={(e) => {
                    onChange(e.target.checked);
                    if (props.onChange) {
                      props.onChange(e);
                    }
                  }}
                  style={style ? style : {}}
                />
                {"   "}
                {title}
              </label>
            </div>
          </>
        )}
      />
    </>
  );
});
